import { callCampaignStatuses } from "@/src/constants/callConstants.js";
import { imageNames } from "@/src/constants/imageConstants.js";

export const campaignFieldTypes = {
  PHONE_NUMBER: "phoneNumber",
  VOICE_AGENT: "voiceAgent",
  COOLDOWN: "cooldown",
  RECORDING: "recording",
  AUDIENCE: "audience",
  ACTION_BUTTONS: "actionButtons",
  PARALLEL_CALLS: "parallelCalls",
  DNC_FOLLOW: "dncFollow",
  TIMEZONE_SETTINGS: "timezoneSettings",
  MAP_VARIABLES: "mapVariables",
};

export const defaultActiveDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

export const numberSelectionOptions = [
  { value: "specific", label: "Specific numbers only" },
  { value: "auto", label: "Auto pick local number" }
];

export const campaignFilterIds = {
  STATUS: "status",
  DISPOSITION: "disposition",
  TIMEZONE: "timezone",
};

export const statusTagMapping = {
  [callCampaignStatuses.COMPLETED]: {
    text: "Completed",
    icon: imageNames.CHECK_ROUNDED_WHITE_EMPTY,
    container: "container_green",
  },
  [callCampaignStatuses.ENDED]: {
    text: "Ended",
    icon: imageNames.ENCLOSED_CROSS_GREY,
    container: "container_red",
  },
};
export const campaignFilters = [
  {
    id: "status",
    name: "Status",
    type: "select",
    options: [
      { id: "", name: "Pending" },
      { id: "voicemail", name: "Voicemail" },
      { id: "voicemail-dropped", name: "Voicemail Dropped" },
      { id: "failed", name: "Failed" },
      { id: "no-answer", name: "No Answer" },
      { id: "out-of-timezone", name: "Out of Timezone" },
      { id: "busy", name: "Busy" },
      { id: "cancelled", name: "Cancelled" },
      { id: "do-not-call", name: "Do Not Call" },
      { id: "skipped", name: "Skipped" },
      { id: "entity-missing", name: "Entity Not Found" },
      { id: "insufficient-credits", name: "Insufficient Credits" },
      { id: "completed", name: "Completed" },
    ],
    searchable: true,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "disposition",
    name: "Disposition",
    type: "select",
    options: [], 
    searchable: true,
    multiSelect: true,
    showInitials: false,
  },
  {
    id: "timezone",
    name: "Timezone",
    type: "select",
    options: [],
    searchable: true,
    multiSelect: true,
    showInitials: false,
  }
];

export const campaignFieldConfigurations = {
  voice_agent_campaign: [
    {
      type: campaignFieldTypes.VOICE_AGENT,
      modelKey: "voiceAgentId",
      dataKey: "voiceAgents",
      propName: "voice-agents",
    },
    {
      type: campaignFieldTypes.PARALLEL_CALLS,
      modelKey: "parallelCalls",
    },
    {
      type: campaignFieldTypes.PHONE_NUMBER,
      modelKey: "phoneNumberId",
      dataKey: "phoneNumbers",
      propName: "phone-numbers",
    },
    {
      type: campaignFieldTypes.AUDIENCE,
      condition: "isCreate",
      staticProps: {
        source: "voice_agent_campaign",
        campaignPrefix: "voice_agent_campaign",
      },
      dataKey: "formData",
      propName: "form-data",
    },
    {
      type: campaignFieldTypes.MAP_VARIABLES,
      condition: "isCreate",
      dataKey: "mapVariablesData",
      events: ["openModal"],
    },
    {
      type: campaignFieldTypes.RECORDING,
      condition: "isCreate",
      modelKey: "isRecordingEnabled",
    },
    {
      type: campaignFieldTypes.DNC_FOLLOW,
      modelKey: "dncFollow",
    },
    {
      type: campaignFieldTypes.TIMEZONE_SETTINGS,
      modelKey: "timezoneData",
    },
    {
      type: campaignFieldTypes.ACTION_BUTTONS,
      condition: "isCreate",
      dataKey: "actionButtonsData",
      events: ["cancel", "create"],
    },
  ],
  call_campaign: [
    {
      type: campaignFieldTypes.COOLDOWN,
      modelKey: "cooldownDuration",
    },
    {
      type: campaignFieldTypes.AUDIENCE,
      condition: "showAudience",
      staticProps: {
        source: "call_campaigns",
      },
      dataKey: "formData",
      propName: "form-data",
    },
    {
      type: campaignFieldTypes.RECORDING,
      modelKey: "isRecordingEnabled",
      condition: "isCreate",
    },
    {
      type: campaignFieldTypes.DNC_FOLLOW,
      modelKey: "dncFollow",
    },
    {
      type: campaignFieldTypes.TIMEZONE_SETTINGS,
      dataKey: "timezoneData",
    },
    {
      type: campaignFieldTypes.ACTION_BUTTONS,
      condition: "isCreate",
      dataKey: "actionButtonsData",
      events: ["cancel", "create"],
    },
  ],
};